import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { EUserType } from "../enums/EUserType";

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    allPaths = {
        customer: {
            '/admin-users': true,
        },
        // staff: {
        //     '/staff-dashboard': true,
        //     '/client': true,
        //     '/policies': true,
        //     '/agent': true,
        //     '/sub-agent': true,
        //     '/near-expire': true,
        //     '/email-sent-logs': true,
        //     '/product-type': true,
        //     '/customer-policies': true,
        //     '/performance-report': true,
        //     '/reminder': true,
        // },
    }


    constructor(
        private authService: AuthService,
        private router: Router,
    ) {
    }

    // @ts-ignore
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        let user = this.authService.gUser;
        // if (user && user._id) {
        //     if (user.usr_type_str === EUserType.CUSTOMER) {
        //         // @ts-ignore
        //         if (this.allPaths.customer[state.url]) return true;
        //         else {
        //             this.router.navigate(['admin-users']);
        //             return false;
        //         }
        //     }
        // } else {
        //     this.router.navigate(['login']);
        //     return false;
        // }
    }

}
